 function validaTel(val) {  //Regra de formatação - colocar regra de digitos aqui
  if(!val)
    return true;

  let len = val.toString().replace(/[^0-9]/g, '').length;
  if(len == 10 )
    return true;

  return false;
}

export default {
  messages: {
    en: (field, args) => {
      return "Telefone inválido";
    },
    'pt-BR': (field, args) => {
      return "Telefone inválido";
    }
  },
  validate(value) {
    return validaTel(value);
  },
};



// WEBPACK FOOTER //
// ./src/validators/phone.js